
<div>
    <app-bar :title="t('races_title')"></app-bar>

    <v-layout>
        <race-execution-collection></race-execution-collection>
    </v-layout>
</div>
